import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {

  transform(value: boolean, args?: string[]): any {
    let trueValue = 'Yes';
    let falseValue = 'No';
    if (args && args.length == 2) {
      trueValue = args[0];
      falseValue = args[1];
    }
    return value == true ? trueValue : falseValue;
  }

}
